import { useReducer } from 'react';

function useForceRender() {
  const [, forceRender] = useReducer((s) => s + 1, 0);

  return forceRender;
}

export default useForceRender;
